import script from "./DetalhesPedidoVendaEnxuto.vue?vue&type=script&setup=true&lang=js"
export * from "./DetalhesPedidoVendaEnxuto.vue?vue&type=script&setup=true&lang=js"

import "./DetalhesPedidoVendaEnxuto.vue?vue&type=style&index=0&id=0cf08d3e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cf08d3e"]])

export default __exports__